<template>
  <div class="dice-static" v-if="value">
    <span
      class="dice-static__dice"
      :class="['dice-static__dice--a-' + value, 'dice-static__dice--' + color]"
    >
      <span class="dice-static__dice-dot" v-for="(i, key) in value" :key="key"></span>
    </span>
  </div>
</template>
<script>
export default {
  name: 'DiscStatic',
  props: {
    value: {
      type: Number,
      validation: v => {
        return v > 0 && v <= 6;
      },
    },
    color: {
      type: String,
    },
  },
};
</script>
<style lang="scss">
@import '../styles/settings';
.dice-static {
  $dice: 3rem;
  height: $dice;
  position: relative;
  display: flex;
  &:before {
    content: '';
    position: absolute;
    top: calc(50% - 0.125rem);
    left: 0;
    right: 0;
    border-top: 0.25rem solid #ddd;
    transform-style: preserve-3d;
    transform: rotate3d(1, 1, 1, 0deg);
  }
  &__dice {
    $diceb: &;
    width: $dice;
    height: $dice;
    position: absolute;
    transform: translateX(-100%);
    border-radius: 0.25rem;
    left: $dice;
    @for $i from 2 to 7 {
      &--a-#{$i} {
        left: $i / 6 * 100%;
      }
    }
    &--sa {
      background-color: get-color(red);
    }
    &--avg {
      background-color: var(--dice-detail-color, #{get-color(dice-avg)});
    }
    &--user {
      background-color: get-color(dice-user);
    }
    &-dot {
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
      background: get-color(white);
      position: absolute;
      transform: translate(-50%, -50%);
    }
    &--a-1 #{&}-dot {
      &:nth-child(1) {
        left: 50%;
        top: 50%;
      }
    }
    &--a-2 #{&}-dot {
      &:nth-child(1) {
        left: 70%;
        top: 30%;
      }
      &:nth-child(2) {
        left: 30%;
        top: 70%;
      }
    }
    &--a-3 #{&}-dot {
      &:nth-child(1) {
        left: 70%;
        top: 70%;
      }
      &:nth-child(2) {
        left: 50%;
        top: 50%;
      }
      &:nth-child(3) {
        left: 30%;
        top: 30%;
      }
    }
    &--a-4 #{&}-dot {
      &:nth-child(1) {
        left: 30%;
        top: 30%;
      }
      &:nth-child(2) {
        left: 70%;
        top: 30%;
      }
      &:nth-child(3) {
        left: 30%;
        top: 70%;
      }
      &:nth-child(4) {
        left: 70%;
        top: 70%;
      }
    }
    &--a-5 #{&}-dot {
      &:nth-child(1) {
        left: 30%;
        top: 30%;
      }
      &:nth-child(2) {
        left: 70%;
        top: 30%;
      }
      &:nth-child(3) {
        left: 30%;
        top: 70%;
      }
      &:nth-child(4) {
        left: 70%;
        top: 70%;
      }
      &:nth-child(5) {
        left: 50%;
        top: 50%;
      }
    }
    &--a-6 #{&}-dot {
      &:nth-child(1) {
        left: 30%;
        top: 25%;
      }
      &:nth-child(2) {
        left: 30%;
        top: 50%;
      }
      &:nth-child(3) {
        left: 30%;
        top: 75%;
      }
      &:nth-child(4) {
        left: 70%;
        top: 25%;
      }
      &:nth-child(5) {
        left: 70%;
        top: 50%;
      }
      &:nth-child(6) {
        left: 70%;
        top: 75%;
      }
    }
  }
}
</style>